import type { ComponentType } from 'react'
import styled from 'styled-components'

import type { TextProps } from '@awazevr/design-system.components.text'
import { Text } from '@awazevr/design-system.components.text'

const StylableText = Text as unknown as ComponentType<TextProps>

export const StyledStarRatingContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
`

export const StyledStarRatingValue = styled(StylableText)`
  line-height: 1;
  height: 0.9rem;
  margin-left: 0.25rem;
`
